import { atom } from 'jotai'

// Create your atoms and derivatives
export const searchStrAtom = atom('');

export const lowercaseSearchStrAtom = atom(
  (get) => get(searchStrAtom).toLowerCase()
)
